// TODO: Potentially create common component for US, UK, AU, and any other phone number formats during refactor
import React from 'react';
import TextFieldBase from './text-fields/base/TextFieldBase';
import { CleaveBase } from './CleaveBase';

const AUPhoneField = (props: React.ComponentProps<typeof TextFieldBase>) => {
  return <TextFieldBase inputComponent={CleaveInput} {...props} />;
};

export default AUPhoneField;

type CleaveInputProps = {
  inputRef: React.Ref<HTMLInputElement>;
} & React.InputHTMLAttributes<HTMLInputElement>;

const CleaveInput: React.FC<CleaveInputProps> = ({ inputRef, ...props }) => {
  return (
    <CleaveBase
      ref={inputRef}
      options={{
        delimiters: [' ', ' ', ' ext. '],
        blocks: [1, 4, 4, 6],
        delimiterLazyShow: true,
      }}
      {...props}
    />
  );
};
